import { ErrorResponse } from "../../../utils";
import { State } from "./state";
import { Action as TAction, StoreDispatchProps } from "../../../Store";
import { Dispatch } from "redux";
import { actionCreator } from "../../../ajax";

export namespace Actions {
  // ACTION TYPES
  export const REQUEST_GET = "io/request/alertsRecent/get";
  export const REQUEST_POST = "io/request/alertsRecent/post";
  export const RESPONSE_GET = "io/response/alertsRecent/get";
  export const RESPONSE_POST = "io/response/alertsRecent/post";
  export const EDIT = "io/edit/alertsRecent";
  export const POLL_START = "io/poll/alertsRecent/start";
  export const POLL_STOP = "io/poll/alertsRecent/stop";
  export const ALERT_SET = "io/alertsRecent/set/alert";
  export const ALERT_CLR = "io/alertsRecent/clr/alert";
  export const ALERT_CANCEL = "io/alertsRecent/clr/cancel";

  // ACTION INTERFACES
  type Requests = GetRequest | PostRequest;
  export interface GetRequest extends TAction<typeof REQUEST_GET> {}
  export interface PostRequest extends TAction<typeof REQUEST_POST> {
    data: Partial<State.Data>;
  }
  export interface GetResponse extends TAction<typeof RESPONSE_GET> {
    data: State.ServerResponse;
    diff?: number;
  }
  export interface PostResponse extends TAction<typeof RESPONSE_POST> {
    data: ErrorResponse;
  }
  export interface Edit extends TAction<typeof EDIT> {
    data: Partial<State.Data>;
  }
  export interface AlertSet extends TAction<typeof ALERT_SET> {
    data: State.AlertRecentServer;
  }
  export interface AlertCancel extends TAction<typeof ALERT_CANCEL> {
    pending?: number;
  }
  export interface AlertClr extends TAction<typeof ALERT_CLR> {}
  export interface PollStart extends TAction<typeof POLL_START> {}
  export interface PollStop extends TAction<typeof POLL_STOP> {}
  export interface DispatchProps extends StoreDispatchProps<State.Data> {}

  // ACTIONS
  export const getRequest = actionCreator<GetRequest>(REQUEST_GET);
  export const getResponse = actionCreator<GetResponse>(RESPONSE_GET);
  export const postRequest = actionCreator<PostRequest>(REQUEST_POST);
  export const postResponse = actionCreator<PostResponse>(RESPONSE_POST);
  export const edit = actionCreator<Edit>(EDIT);
  export const pollStart = actionCreator<PollStart>(POLL_START);
  export const pollStop = actionCreator<PollStop>(POLL_STOP);
  export const alertSet = actionCreator<AlertSet>(ALERT_SET);
  export const alertClr = actionCreator<AlertClr>(ALERT_CLR);
  export const alertCancel = actionCreator<AlertCancel>(ALERT_CANCEL);
  export function fetchRequest(): GetRequest;
  export function fetchRequest(data: Partial<State.Data>): PostRequest;
  export function fetchRequest(data?: Partial<State.Data>): Requests {
    return data ? postRequest({ data }) : getRequest();
  }

  export const bindDispatchProps = (dispatch: Dispatch) => {
    return {
      edit: (data: Partial<State.Data>) => dispatch(edit({ data })),
      fetch: (data?: Partial<State.Data>) =>
        dispatch(data ? fetchRequest(data) : fetchRequest()),
      poll: (p: boolean) =>
        dispatch(p ? pollStart({ data: p }) : pollStop({ data: p })),
      close: () => dispatch(alertClr()),
      cancel: () => dispatch(alertCancel())
    };
  };
}
export default Actions;
